import React, { useState, useRef, useEffect } from 'react';
import { Formik, Field } from 'formik';
import { Container, Form, Col, ButtonToolbar, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

import { addClient, validateRecaptcha } from '../../scripts/api/externalFormApi';
import transform from '../../scripts/transformer';

import { message } from '../shared/Message';
import Demographics from '../shared/demographics/Demographics';
import EditActions from '../shared/EditActions';
import RecaptchaTokenDto from '../../DTOs/shared/RecaptchaTokenDto';

const NewClientIntakeForm = (props) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const demographicsControls = useRef({});
  const [client] = useState({ isActive: true });
  const { id } = useParams();

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  useEffect(() => {
    const scriptUrl = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(() => {
        console.log('reCAPTCHA is ready');
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [siteKey]);

  const onFormSubmit = async (values, actions) => {
    const clientDto = transform.demographicsJsonToClientDto(
      values.demographicsJson,
      props.user.activeDemographicsSchema,
      props.user.demographicsKeywords,
      values);
    clientDto.isDisabled = false;

    message.dismissAll();

    try {
      const actionName = 'newClientForm';
      const token = await window.grecaptcha.execute(siteKey, { action: 'newClientForm' });
      const recaptchaResponse = await validateRecaptcha(new RecaptchaTokenDto(token, actionName));

      if (recaptchaResponse.isValid) {
        await addClient(id, clientDto.stringify());
        setShowSuccess(true);
      } else {
        message.error('reCAPTCHA validation failed.');
      }
    } catch (err) {
      message.error(`Problem creating client: ${err.message}`);
    } finally {
      actions.setSubmitting(false);
    }
  };

  const validateDemographics = () => {
    const demographicsValid = demographicsControls.current.validate();
    return demographicsValid ? null : 'Invalid';
  };

  return (
    <React.Fragment>

      {showSuccess ?
        <React.Fragment>
          Your submission was successful.
        </React.Fragment> : null}

      {!showSuccess && props && props.user && props.user.demographicsKeywords !== null && props.user.activeDemographicsSchema !== null ?
        <Formik
          onSubmit={onFormSubmit}
          initialValues={{ ...client }}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleSubmit,
            values,
            isSubmitting
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Container className="basic-card pb-1">
                <Field name="demographicsJson" validate={validateDemographics} value={values.demographicsJson}>
                  {({ field, form }) => (
                    <Demographics
                      onControlsCreated={controls => demographicsControls.current = controls}
                      schema={props.user.activeDemographicsSchema}
                      onChange={answers => form.setFieldValue(field.name, answers)}
                    />
                  )}
                </Field>
              </Container>

              <EditActions>
                <Col>
                  <ButtonToolbar className="d-flex justify-content-end">
                    <Button
                      className="g-recaptcha"
                      variant="primary"
                      type="submit"
                      disabled={isSubmitting}
                      data-sitekey={siteKey}
                      data-callback='onFormSubmit'
                      data-action='submit'>Submit</Button>
                  </ButtonToolbar>
                </Col>
              </EditActions>
            </Form>
          )}
        </Formik>
        : null
      }
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(
  mapStateToProps
)(NewClientIntakeForm)
